'use client'
import { MediaImageStandard, Typography } from 'components/Contentful'
import { AchieveLink } from 'components/AchieveLink'
import { mainProductConfig } from 'constants/mainProductConfig'
import {} from 'react'

function AuthorAvatar({ authorPhoto, index, href, authorName, priority = false }) {
  const siteEnv = process.env.NEXT_PUBLIC_SITE_ENVIRONMENT || 'achieve'
  return (
    <div className={'flex flex-row gap-2 [&_a]:hover:text-blue-400'} data-testid="author-container">
      {authorPhoto ? (
        <MediaImageStandard
          className={'min-w-[40px] min-h-[40px] w-10 h-10 bg-neutral-150 rounded-lg'}
          alt={authorName}
          content={authorPhoto}
          layout="fixed"
          width={40}
          height={40}
          fetchPriority="high"
          preload={priority}
          objectFit="cover"
          data-testid="author-image"
        />
      ) : (
        <div
          className={'min-w-[40px] min-h-[40px] w-10 h-10 bg-neutral-150 rounded-lg'}
          data-testid="author-no-image"
        ></div>
      )}
      <div data-testid="author-info-container">
        <AchieveLink
          track={{
            list_name: 'AUTHOR VIEW PROFILE LINK',
            click_position: index,
            click_id: 'View Profile',
            click_text: `${
              mainProductConfig[siteEnv || 'achieve']?.['MainProductHyphen']
            } | View Profile`,
          }}
          href={href}
          data-testid="author-view-profile-link"
          className={'text-neutral-900'}
        >
          <Typography
            content={authorName}
            variant="labelSm"
            className={'hover:text-blue-400'}
            data-testid="author-name"
          />
        </AchieveLink>
        <Typography
          className={'text-neutral-300'}
          content={'Author'}
          variant="bodySm"
          data-testid="author-role-text"
        />
      </div>
    </div>
  )
}

export { AuthorAvatar }
export default AuthorAvatar
